const Spacer = props => {
  return (
    <div style={{height:props.height}}></div>
  );
}

export default Spacer;
